import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ContributionEnumIcon from '@/components/common/contribution/ContributionEnumIcon';
import { DONATION_TYPE_OPTIONS } from '@/lib/configs/selectOptionsConfig';
import translate from '@/lib/intl/translate';

const MENU_PROPS = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
};

function DonationTypeSelect({ className, onChange, value, required }) {
  const internalValue = React.useMemo(
    () => DONATION_TYPE_OPTIONS.filter((item) => value?.includes(item.value)),
    [value],
  );

  const handleChange = (event) => {
    onChange(event.target.value.map((item) => item.value));
  };

  return (
    <FormControl className={classNames(className, 'w-full')} size="small">
      <InputLabel id="donation-type-select-label">
        {translate('CONTRIBUTION_TYPE_LABEL')}
      </InputLabel>
      <Select
        labelId="donation-type-select-label"
        id="donation-type-select"
        label={translate('CONTRIBUTION_TYPE_LABEL')}
        multiple
        required={required}
        value={internalValue}
        onChange={handleChange}
        MenuProps={MENU_PROPS}
        renderValue={(selected) => (
          <div className="max-w-full truncate">
            {selected.map((item, i) => (
              <div key={item.value} className="mr-3 inline-flex items-center">
                <ContributionEnumIcon
                  enumValue={item.value}
                  type={ContributionEnumIcon.donationType}
                />
                {i < selected.length - 1 ? ',' : ''}
              </div>
            ))}
          </div>
        )}
      >
        {DONATION_TYPE_OPTIONS.map((item) => (
          <MenuItem key={item?.value} value={item}>
            <div className="flex w-full items-center">
              <ContributionEnumIcon
                enumValue={item.value}
                type={ContributionEnumIcon.donationType}
              />
              <Checkbox
                className="ml-auto"
                checked={internalValue.includes(item)}
              />
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

DonationTypeSelect.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.array,
};

DonationTypeSelect.defaultProps = {
  className: '',
  onChange: () => {},
  required: false,
  value: [],
};

export default DonationTypeSelect;
